/**
 * @generated SignedSource<<308760b65005027f3e9818883aa6703d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type updateAxonIdentityProviderMutation$variables = {
  agencyDomain: string;
  nodeId: string;
};
export type updateAxonIdentityProviderMutation$data = {
  readonly updateAxonIdentityProvider: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly identityProviderConfiguration: {
      readonly axonConnectDomain: string | null;
      readonly id: string;
      readonly name: string;
      readonly providerType: identityprovidertype;
      readonly uuid: string;
    } | null;
  } | null;
};
export type updateAxonIdentityProviderMutation = {
  response: updateAxonIdentityProviderMutation$data;
  variables: updateAxonIdentityProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agencyDomain"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "agencyDomain",
        "variableName": "agencyDomain"
      },
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "nodeId"
      }
    ],
    "concreteType": "UpdateAxonIdentityProvider",
    "kind": "LinkedField",
    "name": "updateAxonIdentityProvider",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentityProviderConfiguration",
        "kind": "LinkedField",
        "name": "identityProviderConfiguration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "providerType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "axonConnectDomain",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "updateAxonIdentityProviderMutation",
    "selections": (v2/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "updateAxonIdentityProviderMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2a48bd2efd3165fe8341c748ebfaa60e",
    "id": null,
    "metadata": {},
    "name": "updateAxonIdentityProviderMutation",
    "operationKind": "mutation",
    "text": "mutation updateAxonIdentityProviderMutation(\n  $nodeId: ID!\n  $agencyDomain: String!\n) {\n  updateAxonIdentityProvider(nodeId: $nodeId, agencyDomain: $agencyDomain) {\n    identityProviderConfiguration {\n      id\n      uuid\n      name\n      providerType\n      axonConnectDomain\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "f94de842b8e63dfb565ef64c9055cebd";

export default node;
